import './style.less';

import clsx from 'clsx';
import React from 'react';

import Icons, { IconType } from './runtime';

export type IconProps = React.SVGProps<SVGSVGElement> & {
  type: IconType;
  className?: string;
  name?: string;
  spin?: boolean;
  size?: number;
  fill?: string;
};

export const Icon: React.FC<IconProps> = props => {
  const { type, className, spin, name, size, fill, ...other } = props;
  const ariaProps =
    typeof name === 'string' ? { 'aria-label': name } : { 'aria-hidden': true };

  return React.createElement(Icons(type), {
    ...ariaProps,
    ...other,
    className: clsx('jarvis-icon', { 'is-spin': spin }, className),
    style: {
      fontSize: size,
      color: fill,
    },
  });
};
export default Icon;
